import { getRecoil } from "recoil-nexus";
import { socket } from "../index";
import roomDetailState from "../../atoms/roomDetail";

const emitKickUser = (userId: string) => {
  const roomDetail = getRecoil(roomDetailState);
  const roomId = roomDetail.id;
  socket?.emit('KICK_USER', { roomId, userId });
}

export default emitKickUser;